<section class="summary-results-pane-value">
  <span class="titles">{{summarySectionTitle}}</span>
  <div class="summary-details">
    <gen-dynamic-form
      [listenToDataChange]="true"
      [formData]="formData"
      [formName]="formName"
      (formChange)="updateForm($event.form, $event.updated)"
      [requiredMessage]="''"
      [disabled]="readOnly"
      [formVertical]="true"
      [editMode]="!(inlineEdit && !readOnly)"
      [updateOnBlur]="false"
      [submitted]="submitted"
      [updatedFieldsContext]="updatedFieldsContext"
      [triggerReflects] = "fields"
    ></gen-dynamic-form>
  </div>
</section>
